import React from "react";
import Link from "next/link";
import { makeStyles } from 'tss-react/mui';

// @mui/icons-material
import Chat from "@mui/icons-material/Chat";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Fingerprint from "@mui/icons-material/Fingerprint";
import LocationOn from "@mui/icons-material/LocationOn";
import VerifiedUser from "@mui/icons-material/VerifiedUser";

// core components
import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem.js";
import InfoArea from "../components/InfoArea/InfoArea.js";
import Button from "../components/CustomButtons/Button.js";
import Card from "../components/Card/Card.js";
import CardBody from "../components/Card/CardBody.js";
import CardFooter from "../components/Card/CardFooter.js";

import styles from "../styles/jss/nextjs-material-kit/pages/landingPageSections/jobAndCoursesSideBarStyle.js";
import { useJobsListRequest } from "../request/api.ts";
import { format as formatDate } from "../util/date.ts";
import { buildSlug } from "../util/url.ts";
import JobCard from "../components/JobCard/JobCard.js";
import Grid from "@mui/material/Grid";
import Image from "next/image";

const useStyles = makeStyles()(styles);

export default function EmployerJobsSidebar({ headingText = 'Latest jobs', careerZones, org, excludeId = undefined, isUniversity = false }) {
  const { classes, cx } = useStyles();

  const { data, error, isLoading } = useJobsListRequest({
    career_zone_ids: careerZones || [],
    employer_id: org ? org.id : null,
    limit: 5,
  });

  const jobs = data?.jobs.filter(job => job.id !== excludeId) || [];

  const noJobs = (
    <Card
      style={{ paddingBottom: 0 }}
      className={cx(
        classes.jobSection,
        classes.jobCard,
        classes.cardFooter,
        classes.marginBottom,
        classes.roundedBottom,
      )}
    >
      <p>None right now.</p>

      <Button
        style={{ boxShadow: "none" }}
        className={cx(classes.darkButton, classes.largePillButton)}
        color="info"
        component={Link}
        href="/jobs"
      >
        See all
      </Button>
    </Card>
  );

  return (
    <div className={[classes.section, "aassaaasasa"].join(" ")}>
      <div className={cx(classes.container, "sidebar")}>
        <Grid container>
          <Grid item
            className={cx(classes.paddingZero)}
            xs={12}
            sm={12}
            md={12}
          >
            <Card
              style={{ paddingBottom: 0 }}
              className={cx(
                classes.jobCard,
                classes.employerJobsContainer,
              )}
            >
              <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 0 }}>
                <h4
                  className={cx(classes.title, classes.employerJobsHeading)}
                >
                  {headingText}
                </h4>
              </Grid>
              {org && <div className={cx(classes.logoContainer, classes.roundedTop)}>
                <img
                  src={org.logo_uri}
                  alt={`${org.name} logo`}
                />
              </div>}
              {jobs.length ? jobs.map((job, index) => (
                <Link key={`job-${job.id}`} href={`/${buildSlug(job.type)}/${buildSlug(job.organisation.name)}/${buildSlug(job.jobType)}/${buildSlug(job.title)}/${job.id}`}>
                  <div className={cx(classes.jobSection, "link-card", classes.marginBottom, index === 0 ? classes.roundedBottom : classes.rounded)}>
                    {/* If the whole sidebar ISN'T for a fixed employer, each job should show the employer logo */}
                    {!org && <div className={cx(classes.logoContainer, classes.logoContainerPerJob)} style={{ position: 'relative', height: '100px' }}>
                      <Image
                        width={200}
                        height={100}
                        style={{
                          objectFit: 'contain',
                        }}
                        src={job.organisation.logo_uri}
                        alt={`${job.organisation.name} logo`}
                      />
                    </div>}
                    <JobCard job={job} className={classes.rounded}/>
                  </div>
                </Link>
              )) : (isLoading ? <p>Loading&hellip;</p> : noJobs)}
            </Card>
          </Grid>
          {jobs.length > 0 && (
            <Grid item xs={12} alignItems={"center"} alignContent={"center"}>
              <Button
                style={{ boxShadow: "none" }}
                className={cx(classes.darkButton, classes.largePillButton)}
                color="info"
                component={Link}
                href={`/jobs${org ? `?organisation=${org.id}` : ""}`}
              >
                See all
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
}
